var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('mReferences'),_vm._l((_vm.productOptions),function(productOption,productOptionsIndex){return _c('mProductCard',{key:`productType-${productOptionsIndex}`,attrs:{"product":productOption}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }